module.exports = __webpack_public_path__ + "img/hinten nacht.fe076caf.jpg";